import React from 'react';

const ChallengeTypePhoto = () => {
    return <></>;
};

export default ChallengeTypePhoto;
